import { useSelector } from 'react-redux';
import Toast from './Toast';
import { ToastsContainerWrapper } from './Toast.style';

const ToastsContainer = () => {
  const toasts = useSelector(state => state.common.toasts);

  return (
    <ToastsContainerWrapper>
      {toasts.map(toast => (
        <Toast key={toast.id} {...toast} />
      ))}
    </ToastsContainerWrapper>
  );
};

export default ToastsContainer;
